'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ./~/react-slick/lib/index.js
// module id = ./node_modules/react-slick/lib/index.js
// module chunks = 137591856104208 266772403791747